window.config = require('./config-kraftorte');
window.viewmode = "kraftorte";

import './table.js';
